import { useEffect, useRef, useState } from "react";
import Lightbox from "yet-another-react-lightbox";
import Zoom from "yet-another-react-lightbox/plugins/zoom";
import "yet-another-react-lightbox/styles.css";
import { ViewerCaption, ViewerClose, ViewerNavigation, ViewerZoom } from "./ViewerControls";
import { ViewerSlide, ViewerStatus } from "./ViewerSlide";
import { trapViewerFocus } from "./focus";

const LABELS = {
    Lightbox: "Visualizzatore immagini", Close: "Chiudi", Previous: "Immagine precedente",
    Next: "Immagine successiva", "Zoom in": "Ingrandisci", "Zoom out": "Riduci",
    Slide: "Immagine", "{index} of {total}": "{index} di {total}",
};

export const ImageViewer = ({ gallery, close }) => {
    const controller = useRef(null);
    const [compact, setCompact] = useState(() => window.matchMedia("(max-width: 600px)").matches);
    useEffect(() => {
        const query = window.matchMedia("(max-width: 600px)");
        const update = () => setCompact(query.matches);
        query.addEventListener("change", update);
        return () => query.removeEventListener("change", update);
    }, []);
    return (
        <Lightbox open close={close} index={gallery.index} slides={gallery.slides}
            plugins={[Zoom]} className="apf-viewer" labels={LABELS}
            controller={{ ref: controller, closeOnBackdropClick: true }}
            portal={{ container: {
                "data-testid": "image-viewer-modal", "data-lenis-prevent": "",
                tabIndex: -1, onKeyDownCapture: trapViewerFocus,
                onClick: (event) => { if (event.target === event.currentTarget) controller.current?.close(); },
            } }}
            carousel={{ finite: true, preload: 1, padding: compact ? "16px" : "80px", spacing: "16%", imageFit: "contain",
                imageProps: (slide) => ({ "data-testid": `image-viewer-image-${slide.viewerId}` }) }}
            zoom={{ maxZoomPixelRatio: 2, zoomInMultiplier: 2, scrollToZoom: true }}
            animation={{ fade: 300, swipe: 400, zoom: 300, easing: { fade: "ease-out", swipe: "cubic-bezier(0.16, 1, 0.3, 1)" } }}
            render={{
                controls: () => <ViewerCaption />,
                buttonClose: () => <ViewerClose key="viewer-close" />,
                buttonPrev: () => <ViewerNavigation direction="prev" />,
                buttonNext: () => <ViewerNavigation direction="next" />,
                buttonZoom: (props) => <ViewerZoom key="viewer-zoom" {...props} />,
                slideContainer: (props) => <ViewerSlide {...props} />,
                iconLoading: () => <ViewerStatus />,
                iconError: () => <ViewerStatus error />,
            }}
        />
    );
};